'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import uuidValidator from '@haaretz/s-validators/uuidValidator';
import React from 'react';
const ArticleIdContext = /*#__PURE__*/ React.createContext(undefined);
const ArticleIdSetter = /*#__PURE__*/ React.createContext(undefined);
export function ArticleIdProvider({ children, value: defaultArticleId }) {
    const [articleId, setArticleId] = React.useState(defaultArticleId);
    const articleIdSetter = React.useCallback((value)=>{
        const newArticleId = value && uuidValidator(value) ? value : null;
        setArticleId(newArticleId);
    }, []);
    return /*#__PURE__*/ _jsx(ArticleIdContext, {
        value: articleId,
        children: /*#__PURE__*/ _jsx(ArticleIdSetter, {
            value: articleIdSetter,
            children: children
        })
    });
}
export default function useArticleId() {
    const context = React.use(ArticleIdContext);
    if (context === undefined) {
        throw new Error('useArticleId must be used within a ArticleIdProvider');
    }
    return context;
}
export function useSetArticleId() {
    const context = React.use(ArticleIdSetter);
    if (context === undefined) {
        throw new Error('useSetArticleId must be used within a ArticleIdProviderMutator');
    }
    return context;
}
export function useArticleIdAtom() {
    return [
        useArticleId(),
        useSetArticleId()
    ];
}

//# sourceMappingURL=articleIdAtom.js.map